const pym = require("./lib/pym");
const track = require("./lib/tracking");
const {format} = require("d3-format");
const ratioChart = require("./chart.js");

const ratios = [
  {
    band: "mi",
    label: ["Middle income", "units"],
    units: 3149,
    applications: 386368
  },
  {
    band: "mo",
    label: ["Moderate", "income units"],
    units: 2086,
    applications: 526722
  },
  {
    band: "li",
    label: ["Low income", "units"],
    units: 12089,
    applications: 4282713
  },
  {
    band: "vli",
    label: ["Very low", "income units"],
    units: 3371,
    applications: 1829943
  },
  {
    band: "eli",
    label: ["Extremely low", "income units"],
    units: 121,
    applications: 78689
  }
].map(d => ({...d, ratio: d.applications / d.units}));
const defaultRatio = {
  band: "user",
  label: ["Applications per unit", "you qualify for"],
  units: 4737,
  applications: 2870647,
  ratio: 606
};
const averageRatio = {
  band: "average",
  label: ["Applications per", "unit citywide"],
  units: 21382,
  applications: 6714209,
  ratio: 314
};
const defaultCPRatio = {
  units: 4737,
  applications: 2870647,
  unitsCD: 75,
  applicationsCD: 56457,
  unitsCP: 75,
  applicationsCP: 56457
};

const boroughs = ["Manhattan", "The Bronx", "Brooklyn", "Queens", "Staten Island"];
const ranges = {
  "eli": "extremely low income",
  "vli": "very low income",
  "li": "low income",
  "mo": "moderate income",
  "mi": "middle income",
  "other": "\"other\""
};

const formTarget = document.querySelector("#lottery-form");
const cpFormTarget = document.querySelector("#lottery-cp-form");
const bandChartTarget = document.querySelector("#band-chart");

formTarget && addForm(formTarget);
cpFormTarget && addCPForm(cpFormTarget);
bandChartTarget && addBandChart(bandChartTarget);

function addBandChart(chartTarget) {
  const chart = ratioChart(chartTarget);
  const update = chart(ratios, 120, ["Applications", "per unit"]);
  window.addEventListener("resize", update);
}

function addForm(form) {
  const incomeField = document.querySelector("#lottery-income");
  const sizeField = document.querySelector("#lottery-size");
  const output = document.querySelector("#output");

  const chartTarget = document.querySelector(".chart");
  const chart = ratioChart(chartTarget);

  // Prevent non-numeric entry
  incomeField.addEventListener("keypress", preventNonNumeric);
  sizeField.addEventListener("keypress", preventNonNumeric);

  sizeField.value = 2;
  incomeField.value = 35000;

  outputResult(2, 35000, defaultRatio);
  const update = chart([averageRatio, defaultRatio], 165);
  window.addEventListener("resize", update);

  form.addEventListener("submit", async e => {
    e.preventDefault();

    track("submit", "overall-ratio");

    const income = Number(incomeField.value);
    const size = Number(sizeField.value);

    const ratio = await getRatio(size, income);
    outputResult(size, income, ratio);

    if (ratio.units) {
      chartTarget.classList.remove("hidden");
      const update = chart([averageRatio, {
        band: "user",
        label: ["Applications per unit", "you qualify for"],
        units: ratio.units,
        applications: ratio.applications,
        ratio: Math.round(ratio.applications / ratio.units)
      }], 165);
      window.addEventListener("resize", update);
    } else {
      chartTarget.classList.add("hidden");
    }
  });
}

function addCPForm (form) {
  const incomeField = document.querySelector("#lottery-income");
  const sizeField = document.querySelector("#lottery-size");
  const addressField = document.querySelector("#lottery-address");
  const output = document.querySelector("#output");

  const chartTarget = document.querySelector(".chart");
  const chart = ratioChart(chartTarget);

  // Prevent non-numeric entry
  incomeField.addEventListener("keypress", preventNonNumeric);
  sizeField.addEventListener("keypress", preventNonNumeric);

  sizeField.value = 2;
  incomeField.value = 35000;
  addressField.value = "476 5th Ave, New York, NY 10018";

  outputCPResult({
    housenumber: "476",
    street: "5 AVENUE",
    borough: "Manhattan",
    region_a: "NY",
    postalcode: "10018"
  }, "Manhattan", "5", 35000, 2, defaultCPRatio);
  const update = chart(getCPData(defaultCPRatio), 140, ["Applications per", "unit you qualify for"]);
  window.addEventListener("resize", update);

  form.addEventListener("submit", async e => {
    e.preventDefault();

    track("submit", "cp-ratio");

    const income = Number(incomeField.value);
    const size = Number(sizeField.value);
    const address = addressField.value;

    try {
      const addressParts = await geocodeAddress(address);
      const cd = await getCD(addressParts.housenumber, addressParts.street, addressParts.postalcode);

      const borough = boroughs[cd.communityDistrictBoroughCode - 1];
      const district = cd.communityDistrictNumber.replace(/^0+/, "");
      const ratio = await getRatio(size, income, cd.communityDistrict);

      track("submit-cd", `${borough} ${district}`);
      outputCPResult(addressParts, borough, district, income, size, ratio);

      if (ratio.unitsCP) {
        chartTarget.classList.remove("hidden");
        const update = chart(getCPData(ratio), 140, ["Applications per", "unit you qualify for"]);
        window.addEventListener("resize", update);
      } else {
        chartTarget.classList.add("hidden");
      }
    } catch (e) {
      console.error(e);
      output.innerHTML = `<p>Could not find community district. Try a different address.</p>`;
      chartTarget.classList.add("hidden");
    }
  });
}

function outputResult (size, income, ratio) {
  output.innerHTML = `\
      <p>A household of ${size} with an annual income of $${format(",")(income)} would have qualified for <strong>${format(",")(ratio.units)} apartments</strong> in lotteries for new "Housing New York" apartments between 2014 and 2019.</p>
      ${ratio.units ? `<p>There were <strong>${format(",")(ratio.applications)} applicants</strong> that qualified for the same apartments based on income and household size.</p>` : ""}\
      `;
}

function outputCPResult (addressParts, borough, district, income, size, ratio) {
  output.innerHTML = `\
      <p>Showing results for: <strong>${addressParts.housenumber} ${addressParts.street}, ${addressParts.borough}, ${addressParts.region_a} ${addressParts.postalcode}</strong></p>
      <p>A household of ${size} with an annual income of $${format(",")(income)} would have qualified for <strong>${format(",")(ratio.unitsCD)} apartments</strong> in ${borough} Community District ${district} in lotteries for new "Housing New York" apartments between 2014 and 2019.</p>
      ${ratio.unitsCD ? `<p>If you live in ${borough} CD ${district}, you would have had priorty for <strong>${Math.round(ratio.unitsCP/2)} apartments</strong> set aside for community preference that you are eligible for.</p>` : ""}\
      `;
}

function ami(size) {
  // VLI max (50% AMI) for family of four in 2012
  const base = 56850;
  // Caclculate family adjustment of VLI.
  const rawVLI = base - base * 0.1 * Math.max(4 - size, 0) + base * 0.08 * Math.max(size - 4, 0);
  // Round up to nearest 50. Multiply by 2 for 100% AMI.
  return Math.ceil((rawVLI) / 50) * 50 * 2;
}

function getBracket(income, size) {
  const pct = income / ami(size);
  const brackets = [
    ["eli", 0],
    ["vli", 0.3],
    ["li", 0.5],
    ["mo", 0.8],
    ["mi", 1.2],
    ["other", 1.65]
  ];

  return brackets.reduce((bracket, [label, min]) => {
    return pct > min ? label : bracket;
  }, "");
}

function getCPData (ratio) {
  return [
    {
      band: "no-cp",
      label: ["Total applications", "per apartment"],
      ratio: Math.round(ratio.applicationsCD / ratio.unitsCD)
    },
    {
      band: "outsider",
      label: ["For \"outsiders\""],
      ratio: Math.round((ratio.applicationsCD - Math.round(ratio.unitsCP / 2)) / (ratio.unitsCD - Math.round(ratio.unitsCP / 2)))
    },
    {
      band: "insider",
      label: ["For \"insiders\""],
      ratio: Math.round(Math.round(ratio.applicationsCP * 0.055) / Math.round(ratio.unitsCP / 2))
    }
  ];
}

function getRatio(size, income, cd) {
  return fetch(`https://d3pnjzczcou1f9.cloudfront.net/?size=${size}&income=${income}${cd ? `&cd=${cd}` : ""}`)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(response.statusText);
      }
    });
}

function geocodeAddress(address) {
  return fetch(`https://geosearch.planninglabs.nyc/v2/search?text=${address}&size=1`)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(response.statusText);
      }
    })
    .then(data => {
      if (data.features.length > 0) {
        return data.features[0].properties;
      } else {
        throw new Error("Address not found.");
      }
    });
}

function getCD(house, street, zip) {
  return fetch(`https://api.nyc.gov/geo/geoclient/v1/address.json?houseNumber=${house}&street=${street}&zip=${zip}`, {
    headers: {
      'Ocp-Apim-Subscription-Key': '1f5f73f546854bd29623a020a7425ead'
    }
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(response.statusText);
      }
    })
    .then(data => data.address);
}

function preventNonNumeric (e) {
  if (e.which < 48 || e.which > 57) {
    e.preventDefault();
  }
}
